/**
 * Mic input level as small vertical bars.
 */
export interface LevelMeterProps {
  /** 0–1 */
  level?: number;
  heights?: number[];
  size?: "sm" | "md";
  className?: string;
}

export function LevelMeter({ level = 0.6, heights, size = "md", className }: LevelMeterProps): JSX.Element {
  const h = heights || (size === "sm" ? [6, 12, 16, 9, 6] : [6, 10, 14, 10, 12, 8, 6]);
  const on = Math.round(level * h.length);
  return (
    <span
      className={["gk-level", size === "sm" && "gk-level--sm", className].filter(Boolean).join(" ")}
      aria-label={"Input level " + Math.round(level * 100) + "%"}
    >
      {h.map((x, i) => (
        <i key={i} className={i < on ? "is-on" : undefined} style={{ height: x }} />
      ))}
    </span>
  );
}
